import Vue from 'vue';
import Vuex from 'vuex';

import api from '../utils/api';
import sso from '../utils/sso';

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== 'production';

const user = {
  state: {
    login_user: {
      mis_id: '',
      username: '',
      email: '',
      avatar: '',
      authority: [],
    },
    menu_list: [],
    router_list: [],
    iosCodeUrl: '',
    androidCodeUrl: '',
  },
  mutations: {
    set_login_user(state, user) {
      state.login_user = user;
    },
    set_menu_list(state, menus) {
      state.menu_list = menus;
    },
    set_ios_code(state, url) {
      state.iosCodeUrl = url;
    },
    set_android_code(state, url) {
      state.androidCodeUrl = url;
    },
  },
  getters: {
    get_login_user(state) {
      return state.login_user;
    },
    get_menu_list(state) {
      return state.menu_list;
    },
    get_ios_code(state) {
      return state.iosCodeUrl;
    },
    get_android_code(state) {
      return state.androidCodeUrl;
    },
  },
  actions: {
    async api_get_login_user(context) {
      return api
        .get('/api_auth/itsec/home/queryLoginUser')
        .then(res => {
          let result = res.data;
          let url = res.avatarUrl;

          if (res.hasOwnProperty('status') && res['status'] === 401) {
            sso.logout();
            return;
          }
          if (res.hasOwnProperty('code') && parseInt(res['code']) !== 0) {
            sso.logout();
            return;
          }
          let { avatarUrl: avatar, email, login: mis_id, name: username, userMenu: authority } = result;
          avatar = url;
          let user = { mis_id, username, email, avatar, authority };
          context.commit('set_login_user', user);
        })
        .catch(() => {
          sso.logout();
        })
        .then(() => {
          api.get('/api_auth/download/moaAndroidFile').then(res => {
            context.commit('set_android_code', res.data);
          });
          api.get('/api_auth/download/moaIosFile').then(res => {
            context.commit('set_ios_code', res.data);
          });
        });
    },
    async api_get_MacFile() {
      return api.get('/api_auth/download/moaMacFile');
    },
    async api_get_WinFile() {
      return api.get('/api_auth/download/moaWinFile');
    },
    async api_get_LinuxFile() {
      return api.get('/api_auth/download/moaLinuxFile');
    },
    async api_get_AndroidFile() {
      return api.get('/api_auth/download/moaAndroidDownloadUrl');
    },
    async api_get_IosFile() {
      return api.get('/api_auth/download/moaIosDownloadUrl');
    },
    async api_get_os_version() {
      return api.get('/api_auth/webConfig/getOsVersion');
    },
    async api_get_MacIntelFile() {
      return api.get('/api_auth/download/moaMacIntelFile');
    },
    async api_get_MacAppleFile() {
      return api.get('/api_auth/download/moaMacAppleFile');
    }
  },
};

const store = new Vuex.Store({
  modules: {
    user,
  },
  strict: debug,
});

export default store;
